(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_upsell-pdp"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__upsellPdpInit) return;
    window.__upsellPdpInit = true;

    var CART_UPDATE_EVENT = 'cart:update';

    function getCartSectionIds() {
      return Array.prototype.slice
        .call(document.querySelectorAll('cart-items-component'))
        .map(function (el) { return el && el.dataset ? el.dataset.sectionId : null; })
        .filter(Boolean);
    }

    function openCartDrawer() {
      try {
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
          return;
        }
      } catch (e) {}

      try {
        if (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) {
          window.location.href = window.Theme.routes.cart_url;
        } else {
          window.location.href = '/cart';
        }
      } catch (e) {}
    }

    async function addToCart(variantId, quantity) {
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', String(quantity));

      var sectionIds = getCartSectionIds();
      if (sectionIds.length) formData.append('sections', sectionIds.join(','));

      var url = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) ? window.Theme.routes.cart_add_url : '/cart/add.js';

      var res = await fetch(url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'text/html'
        },
        body: formData
      });

      return await res.json();
    }

    document.addEventListener('click', async function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-upsell-add]') : null;
      if (!btn) return;

      e.preventDefault();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var quantity = Number(btn.getAttribute('data-quantity') || '1') || 1;

      if (btn.disabled) return;

      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');

      try {
        var data = await addToCart(variantId, quantity);

        // Si Shopify devuelve error, simplemente salimos sin alert/console
        if (data && data.status) return;

        // Dispara el evento que el theme escucha para actualizar drawer + contador
        document.dispatchEvent(new CustomEvent(CART_UPDATE_EVENT, {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: String(variantId),
            data: {
              source: 'product-form-component',
              itemCount: quantity,
              variantId: String(variantId),
              sections: data.sections
            }
          }
        }));

        openCartDrawer();
      } catch (err) {
        // sin alert/console
      } finally {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    (function() {
    /*
     * Position the tooltip so it never overflows the viewport on mobile.
     * If the trigger sits in the right half of the viewport, anchor the
     * tooltip to the trigger's right edge; otherwise leave it anchored left.
     * Runs on load, resize, and orientation change for all devices.
     */
    function positionTooltips() {
      var viewportWidth = window.innerWidth;
      document.querySelectorAll('.shipping-costs-wrapper').forEach(function(wrapper) {
        var trigger = wrapper.querySelector('.shipping-costs-trigger');
        var tooltip = wrapper.querySelector('.shipping-costs-tooltip');
        if (!trigger || !tooltip) return;
        var rect = trigger.getBoundingClientRect();
        var triggerCenter = rect.left + rect.width / 2;
        if (triggerCenter > viewportWidth / 2) {
          tooltip.classList.add('align-right');
        } else {
          tooltip.classList.remove('align-right');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', positionTooltips);
    } else {
      positionTooltips();
    }
    window.addEventListener('resize', positionTooltips);
    window.addEventListener('orientationchange', positionTooltips);

    var isTouchDevice = window.matchMedia('(hover: none), (pointer: coarse)').matches;
    if (!isTouchDevice) return;

    var triggers = document.querySelectorAll('.shipping-costs-trigger');
    var autoCloseTimer = null;

    function closeAll() {
      document.querySelectorAll('.shipping-costs-tooltip.is-active').forEach(function(el) {
        el.classList.remove('is-active');
        var btn = el.previousElementSibling;
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      clearTimeout(autoCloseTimer);
    }

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var tooltip = trigger.nextElementSibling;
        var isOpen = tooltip.classList.contains('is-active');

        closeAll();

        if (!isOpen) {
          positionTooltips();
          tooltip.classList.add('is-active');
          trigger.setAttribute('aria-expanded', 'true');
          autoCloseTimer = setTimeout(closeAll, 5000);
        }
      });
    });

    document.addEventListener('click', function() {
      closeAll();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-description-review"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const readMoreLinks = document.querySelectorAll('[data-scroll-to-accordion]');

    readMoreLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();

        const accordions = document.querySelectorAll('.accordion accordion-custom, accordion-custom');
        let targetAccordion = null;

        for (const accordion of accordions) {
          const summary = accordion.querySelector('summary');
          if (summary) {
            const headingText = summary.textContent.toLowerCase();
            if (headingText.includes('description') || headingText.includes('details')) {
              targetAccordion = accordion;
              break;
            }
          }
        }

        if (!targetAccordion) {
          const accordionContainer = document.querySelector('.product-information__accordion-container');
          if (accordionContainer) {
            targetAccordion = accordionContainer.querySelector('accordion-custom');
          }
        }

        if (!targetAccordion) {
          targetAccordion = document.querySelector('accordion-custom');
        }

        if (targetAccordion) {
          const headerOffset = 100;
          const elementPosition = targetAccordion.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });

          setTimeout(() => {
            const details = targetAccordion.querySelector('details');
            if (details && !details.open) {
              details.open = true;
            }
          }, 500);
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
